<template>
    <div>
        <div class="d-sm-down-none">
            <CRow>
                <CCol sm="6" style="background-size: cover; display: flex; align-items: center; justify-content: center; min-height: 100vh;" class="bg-white">
                    <CContainer style="max-width: 600px; text-align: left;">
                        <div>
                            <h3 class="custom-32px-500 font-color-171717 text-left">Verification</h3>
                            <p class="custom-18px-500">Please enter the code we just sent to <span class="font-color-928AFD"> {{ email }} </span></p>
                        </div>
    
                        <div v-if="ErrorLogin" class="">
                            <CAlert show color="danger">
                                <strong class="text-danger mr-2">Error!</strong> {{ Message }}
                            </CAlert>
                        </div>
                        <CCol md="12" class="text-center mt-3 d-none d-sm-block" style="width: 100%; background-size: cover; margin: auto;">
                                           
                                            <div class="verification-input">
                                                <input v-model="code[0]" maxlength="1" style="width:20%" class="custom-code"/> <span class="custom-48px-400 font-color-101010  mr-2">-</span>
                                                <input v-model="code[1]" maxlength="1" style="width:20%" class="custom-code"/> <span class="custom-48px-400 font-color-101010 mr-2">-</span>
                                                <input v-model="code[2]" maxlength="1" style="width:20%" class="custom-code"/> <span class="custom-48px-400 font-color-101010 mr-2">-</span>
                                                <input v-model="code[3]" maxlength="1" style="width:20%" @change="submitVerification" class="custom-code" />
                                            </div>
                                        </CCol>
                                        <!-- Column for mobile view -->
                                        <CCol xs="12" class="text-center mt-3 d-sm-none" style="width: 100%; background-size: cover; margin: auto;">
                                         
                                            <div class="verification-input">
                                                <input v-model="code[0]" maxlength="1" style="width:20%" class="custom-code mr-2" />
                                                <input v-model="code[1]" maxlength="1" style="width:20%" class="custom-code mr-2" />
                                                <input v-model="code[2]" maxlength="1" style="width:20%" class="custom-code mr-2" />
                                                <input v-model="code[3]" maxlength="1" style="width:20%" class="custom-code" />
                                            </div>
                                        </CCol>
                                        <div style="clear:both"></div>
                                    <div class="text-center mt-5">
                                        <span v-if="lblProcess === true" class="font-color-101010 custom-16px-500">Processing....</span>
                                        <br />  <br />
                                        <span class="custom-border-purple p-2 text-center text-white" v-on:click="submitVerification">
                                                            <label class="ml-2 mr-2">Continue</label></span>
                                        <br />
                                    </div>
                      
    
    
    
    
    
                    </CContainer>
                </CCol>
    
                <CCol sm="6" lg="6" 
       style="background-size: cover; background-position: center; min-height: 100vh;" 
       :style="{ backgroundImage: `url(${backgroundUrl})` }">
                <CRow class="mt-3 p-3">
                    <CCol sm="6">
                        <img src="../assets/img/Logo(1).png" height="32" alt="Interviewrr.ai company logo"/> <span class="custom-20px-500 text-white">Interviewrr</span>
                    </CCol>
                    <CCol sm="6"></CCol>
                    <CCol sm="12">
                        <h3 class="custom-32px-700 text-white mt-5">Effortless e-Voucher Distribution</h3> 
                        <p class="custom-18px-400 text-white">Easily generate and send personalized e-Vouchers automatically, encouraging customer engagement and repeat business with every interaction</p>
                    </CCol>
                </CRow>
                </CCol>
    
            </CRow>
    
        </div>
        <div class="d-md-none d-lg-none bg-white"></div>
    
    
        <div v-if="isLanguagePopupVisible1" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width:100px" src="../assets/img/success.png" />
                    <h3 class="custom-32px-500">Success!</h3>
                    <h3 class="custom-18px text-center">Your account is succesfully registered</h3>
                    <CButton class="custom-border-purple text-white" @click="closePopup"><span class="ml-2 mr-2">OK</span></CButton>
                </div>
    
            </div>
        </div>
    
    
    </div>
</template>

<script>
import Vue from "vue";

import GAuth from 'vue-google-oauth2'

const gauthOption = {
    clientId: '1076578801027-kt1ptr3hd1ou78tlj65vmfaj8tgafq72.apps.googleusercontent.com',
    scope: 'profile email',
    prompt: 'consent',
    fetch_basic_profile: true,
    plugin_name: 'vue-google-oauth2',
}

Vue.use(GAuth, gauthOption)

import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgsecond.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundUrNoArrow,

            backgroundGenie,
            email: this.$route.query.email,
            code: ["", "", "", ""],

            lblProcess: false





        };
    },


    methods: {
        submitVerification() {
            this.verificationCode = this.code.join(""); // Concatenate the digits
            console.log("Verification Code:", this.verificationCode);
            this.ValidateCode(this.verificationCode);
        },
        ValidateCode(verificationCode) {
this.lblProcess = true;
            const formData = new FormData();

            formData.append("userEmail", this.$route.query.email);
            formData.append("code", verificationCode);

            return this.$API
                .post(this.$ValidateForgotPasswordCode, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data > 0) {
                       
                       this.$router.push("ResetPassword?email="+ this.$route.query.email + "&code=" + verificationCode);
                    } else {
                        this.ErrorMessage = true;
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        console.log(error.response.data);
                        this.Error = true;
                        this.Message = error;
                        this.Message = "Error";

                        this.ErrorMessage = true;
                    }
                });
        },



    },

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}
</style>